import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  onChangeType,
  onTouchType,
} from 'src/app/core/models/common/custom.component.model';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormCheckboxComponent),
      multi: true,
    },
  ],
})
export class FormCheckboxComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() customClass = '';
  @Input() isDisabled = false;
  @Output() valueChanged = new EventEmitter<boolean>();
  onChange: onChangeType = () => {};
  onTouch: onTouchType = () => {};
  checked = false;

  registerOnChange(fn: onChangeType): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: onTouchType): void {
    this.onTouch = fn;
  }

  writeValue(checked: boolean) {
    this.checked = checked;
  }

  onModelChange(e: boolean) {
    this.valueChanged.emit(e);
    this.checked = e;
    this.onChange(e);
  }
}
